import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../creators/assets/images/link.png'


const _withScopeId = n => (_pushScopeId("data-v-37229a9b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "p-mb-6" }, "Campaign Details", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Campaign Description", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "p-mb-2" }, "Campaign URLs", -1))
const _hoisted_4 = { class: "talking-link" }
const _hoisted_5 = { class: "p-d-flex p-ai-center p-mb-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "p-p-0 p-m-0" }, "Brand Tracking link input", -1))
const _hoisted_7 = { class: "p-input-icon-left w-100" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-link" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_9 = { class: "talking-link p-mb-6" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Gamekeys (if applicable)", -1))
const _hoisted_11 = { class: "p-input-icon-left w-100" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-link" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_AskHint = _resolveComponent("AskHint")!
  const _component_input_product_urls = _resolveComponent("input-product-urls")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_InputText, {
      class: "default-input w-100",
      type: "text",
      modelValue: $setup.valueProductNameInput,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.valueProductNameInput) = $event)),
      placeholder: "Tell Creators about your campaign"
    }, null, 8, ["modelValue"]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createVNode(_component_AskHint, { class: "p-ml-1" }, null, 512), [
          [
            _directive_tooltip,
            'Add the important link that will be used to track your conversions.' +
         ' For CPI this will be an Adjust or Appsflyer link. For CPC or CPM this will be a general website link',
            void 0,
            { right: true }
          ]
        ])
      ]),
      _createElementVNode("span", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_InputText, {
          class: "default-input w-100 p-pl-6",
          type: "text",
          modelValue: $setup.valueTalkingLinkInput,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.valueTalkingLinkInput) = $event)),
          placeholder: "Enter your link for tracking generation"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("span", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_InputText, {
          class: "default-input w-100 p-pl-6",
          type: "text",
          modelValue: $setup.gamekeys,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.gamekeys) = $event)),
          placeholder: "Enter your link to gamekey folder"
        }, null, 8, ["modelValue"])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.parseProductUrls, (url, index) => {
      return (_openBlock(), _createBlock(_component_input_product_urls, {
        key: `${index}_urs`,
        type: url?.type,
        value: url?.value,
        index: +index,
        onChangeProductUrs: $setup.changedProductUrl,
        class: "ml"
      }, null, 8, ["type", "value", "index", "onChangeProductUrs"]))
    }), 128)),
    _createElementVNode("span", {
      class: "add-another",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.addAnotherProductUrls && $setup.addAnotherProductUrls(...args)))
    }, "+ Add Another URL")
  ]))
}